import { render, staticRenderFns } from "./BaseAutocompleteEvent.vue?vue&type=template&id=ae4353f6"
import script from "./BaseAutocompleteEvent.vue?vue&type=script&lang=ts"
export * from "./BaseAutocompleteEvent.vue?vue&type=script&lang=ts"
import style0 from "./BaseAutocompleteEvent.vue?vue&type=style&index=0&id=ae4353f6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports